import { render, staticRenderFns } from "./AttendeeCallList.vue?vue&type=template&id=2ad94a58&scoped=true&"
import script from "./AttendeeCallList.vue?vue&type=script&lang=js&"
export * from "./AttendeeCallList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad94a58",
  null
  
)

export default component.exports